import { useNavigate } from 'react-router';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    height: '100vh',
    padding: '20px',
    gap: '2rem',
    '@media (max-width: 768px)': {
      justifyContent: 'center',
    },
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: '500px',
    gap: '1rem',
    '@media (max-width: 768px)': {
      maxWidth: '90%',
    },
  },
  heading: {
    fontSize: '2rem',
    fontWeight: '500',
    color: '#2c3e50',
    marginBottom: '20px',
    '@media (max-width: 768px)': {
      fontSize: '1.5rem',
    },
  },
  text: {
    fontSize: '1rem',
    color: '#7f8c8d',
    marginBottom: '30px',
    '@media (max-width: 768px)': {
      fontSize: '0.875rem',
    },
  },
  icon: {
    fontSize: '3rem',
    color: '#2c3e50',
    marginBottom: '30px',
    '@media (max-width: 768px)': {
      fontSize: '2rem',
    },
  },
  button: {
    padding: '10px 20px',
    backgroundColor: '#ff6600',
    color: '#ffffff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '1rem',
    transition: 'background-color 0.3s ease',
    '@media (max-width: 768px)': {
      fontSize: '0.875rem',
      padding: '8px 16px',
    },
  },
  logo: {
    width: '50%', // Scales relative to the parent
    maxWidth: '267px', // Ensures the maximum size
    '@media (max-width: 768px)': {
      width: '70%', // Smaller for narrower screens
    },
  },
  plug: {
    width: '30%', // Scales relative to the parent
    maxWidth: '170px',
    '@media (max-width: 768px)': {
      width: '50%', // Smaller for narrower screens
    },
  },
};

const MeventsIcon = () => (
  <svg
    style={styles.logo}
    viewBox="0 0 267 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M35.178 4.35685C39.6526 4.45105 43.1851 5.3695 45.7285 7.11221C48.2719 8.87847 49.5672 12.199 49.6143 17.121V39.0697H40.3826V18.2514C40.3826 15.0015 39.6997 13.1175 38.3102 12.6229C36.9207 12.1284 34.8483 11.9165 32.093 11.9871C31.6455 12.0342 31.1981 12.0578 30.7506 12.0578H29.3376V39.0697H19.9882V11.9871H9.22579V39.0697H-0.00585938V4.33331H35.178V4.35685Z" fill="#1D2D4E" />
    <path d="M97.1858 8.78429H87.0828C82.043 8.78429 79.7822 9.82049 78.016 12.9056C76.9798 14.6718 76.603 16.179 76.4617 19.4054H97.1858V23.8328H76.4146C76.4617 26.494 76.9798 28.6135 78.0866 30.5917C79.8058 33.559 82.1372 34.6423 86.7766 34.6423H97.1858V39.0697H85.7875C79.6409 39.0697 76.3204 37.7745 73.6592 34.2184C71.3277 31.0862 70.3386 27.5537 70.3386 22.3963C70.3386 15.3077 72.3639 10.2208 76.4381 7.04156C78.8873 5.15755 82.2079 4.33331 87.4125 4.33331H97.2093V8.76071L97.1858 8.78429Z" fill="#6C6D72" />
    <path d="M123.444 39.0933H116.826L101.943 4.35687H108.348L120.218 33.8652L132.252 4.35687H138.233L123.444 39.0933Z" fill="#6C6D72" />
    <path d="M164.869 8.78429H154.766C149.726 8.78429 147.465 9.82049 145.699 12.9056C144.663 14.6718 144.286 16.179 144.145 19.4054H164.869V23.8328H144.098C144.145 26.494 144.663 28.6135 145.77 30.5917C147.489 33.559 149.82 34.6423 154.46 34.6423H164.869V39.0697H153.47C147.324 39.0697 144.003 37.7745 141.342 34.2184C138.987 31.0862 137.998 27.5537 137.998 22.3963C137.998 15.3077 140.023 10.2208 144.098 7.04156C146.547 5.15755 149.867 4.33331 155.072 4.33331H164.869V8.76071V8.78429Z" fill="#6C6D72" />
    <path d="M175.631 39.0933H170.262V4.35687H176.879L194.636 32.1696V4.35687H200.006V39.0933H193.6L175.631 11.3984V39.0933Z" fill="#6C6D72" />
    <path d="M205.328 8.78431V4.35687H234.907V8.78431H222.944V39.0933H217.362V8.78431H205.328Z" fill="#6C6D72" />
    <path d="M238.863 34.6659H253.865C256.479 34.6659 257.868 34.4068 258.975 33.7239C260.435 32.829 261.165 31.3924 261.165 29.3436C261.165 26.6824 260.082 24.869 258.033 24.2332C257.044 23.9741 255.749 23.8564 252.829 23.8564H249.955C245.646 23.8564 242.985 23.3383 241.148 22.0901C238.863 20.5829 237.615 17.9689 237.615 14.8131C237.615 10.9038 239.499 7.58323 242.608 5.81697C244.539 4.78076 246.918 4.35687 251.086 4.35687H265.357V8.78431H251.086C248.024 8.78431 246.658 9.04335 245.457 9.77341C244.256 10.5977 243.479 12.1755 243.479 14.036C243.479 17.5214 245.622 18.8873 251.086 18.8873H253.158C259.258 18.8873 261.707 19.3583 263.615 20.9126C265.758 22.6789 267.006 25.6933 267.006 29.1316C267.006 33.1822 265.192 36.3144 261.966 37.8687C259.988 38.8107 258.01 39.0698 253.158 39.0698H238.84V34.6423L238.863 34.6659Z" fill="#6C6D72" />
    <path d="M61.2248 0H57.3625V43.45H61.2248V0Z" fill="#F87D1D" />
  </svg>
);
const PlugIcon = () => (
  <svg
    style={styles.plug}
    viewBox="0 0 225 225"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M134.16 134.11L115.81 152.45L134.16 170.79C134.903 171.533 135.493 172.416 135.895 173.387C136.297 174.358 136.505 175.399 136.505 176.45C136.505 177.501 136.297 178.542 135.895 179.513C135.493 180.484 134.903 181.367 134.16 182.11C133.417 182.853 132.534 183.443 131.563 183.845C130.592 184.247 129.551 184.454 128.5 184.454C127.449 184.454 126.408 184.247 125.437 183.845C124.466 183.443 123.583 182.853 122.84 182.11L116.5 175.76L93.1901 199.08C87.1809 205.068 79.0434 208.43 70.5601 208.43C62.0767 208.43 53.9392 205.068 47.9301 199.08L42.5601 193.7L14.1601 222.11C13.4168 222.853 12.5344 223.443 11.5632 223.845C10.5921 224.247 9.55121 224.454 8.50005 224.454C7.4489 224.454 6.40803 224.247 5.43688 223.845C4.46574 223.443 3.58334 222.853 2.84005 222.11C2.09677 221.367 1.50717 220.484 1.10491 219.513C0.702646 218.542 0.495605 217.501 0.495605 216.45C0.495605 215.399 0.702646 214.358 1.10491 213.387C1.50717 212.416 2.09677 211.533 2.84005 210.79L31.2501 182.39L25.8701 177.02C22.8978 174.048 20.5401 170.52 18.9314 166.638C17.3228 162.755 16.4949 158.593 16.4949 154.39C16.4949 150.187 17.3228 146.025 18.9314 142.142C20.5401 138.26 22.8978 134.732 25.8701 131.76L49.1901 108.45L42.8401 102.11C41.3389 100.609 40.4956 98.5729 40.4956 96.45C40.4956 94.3271 41.3389 92.2911 42.8401 90.79C44.3412 89.2889 46.3771 88.4456 48.5001 88.4456C50.623 88.4456 52.6589 89.2889 54.1601 90.79L72.5001 109.14L90.84 90.79C92.3412 89.2889 94.3771 88.4456 96.5001 88.4456C98.623 88.4456 100.659 89.2889 102.16 90.79C103.661 92.2911 104.505 94.3271 104.505 96.45C104.505 98.5729 103.661 100.609 102.16 102.11L83.8101 120.45L104.5 141.14L122.84 122.79C124.341 121.289 126.377 120.446 128.5 120.446C130.623 120.446 132.659 121.289 134.16 122.79C135.661 124.291 136.505 126.327 136.505 128.45C136.505 130.573 135.661 132.609 134.16 134.11ZM222.16 2.79001C221.417 2.0462 220.535 1.45613 219.564 1.05353C218.592 0.650938 217.551 0.443718 216.5 0.443718C215.449 0.443718 214.408 0.650938 213.437 1.05353C212.465 1.45613 211.583 2.0462 210.84 2.79001L182.44 31.2L177.07 25.82C171.062 19.8295 162.924 16.4655 154.44 16.4655C145.956 16.4655 137.818 19.8295 131.81 25.82L108.5 49.14L102.16 42.79C100.659 41.2889 98.623 40.4456 96.5001 40.4456C94.3771 40.4456 92.3412 41.2889 90.8401 42.79C89.3389 44.2911 88.4956 46.3271 88.4956 48.45C88.4956 50.5729 89.3389 52.6089 90.84 54.11L170.84 134.11C171.583 134.853 172.466 135.443 173.437 135.845C174.408 136.247 175.449 136.454 176.5 136.454C177.551 136.454 178.592 136.247 179.563 135.845C180.534 135.443 181.417 134.853 182.16 134.11C182.903 133.367 183.493 132.484 183.895 131.513C184.297 130.542 184.505 129.501 184.505 128.45C184.505 127.399 184.297 126.358 183.895 125.387C183.493 124.416 182.903 123.533 182.16 122.79L175.81 116.45L199.13 93.14C202.102 90.1684 204.46 86.6405 206.069 82.7576C207.677 78.8747 208.505 74.7129 208.505 70.51C208.505 66.3071 207.677 62.1453 206.069 58.2625C204.46 54.3796 202.102 50.8516 199.13 47.88L193.75 42.51L222.16 14.11C222.904 13.367 223.494 12.4847 223.897 11.5135C224.299 10.5423 224.506 9.50134 224.506 8.45001C224.506 7.39869 224.299 6.35767 223.897 5.38649C223.494 4.4153 222.904 3.533 222.16 2.79001Z" fill="#202C4C" />
  </svg>

);
const MaintenancePage = () => {
  const navigate = useNavigate();
  return (
    <div style={styles.container}>
      {/* <MeventsIcon /> */}
      <div style={styles.content}>
        <h1 style={styles.heading}>Our site is currently down for maintenance</h1>
        <p style={styles.text}>
          We apologize for any inconvenience caused and will be online as soon
          as possible. Please check again in a little while. Thank you!
        </p>
        {/* <h3 style={styles.heading}>- M Events Crossmedia GmbH</h3> */}
        <PlugIcon />
        <button type="button" style={styles.button} onClick={() => navigate('/')}>
          Back to home
        </button>
      </div>
    </div>
  );
};

export default MaintenancePage;
